import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Field, reduxForm, formValueSelector, SubmissionError, submit } from 'redux-form';
import { indexOf, pick, filter as lodashFilter } from 'lodash';
import Joi from 'joi';

import ConfirmButton from '../../../../components/confirm-button';
// Import Actions
import WindowResizeListener from '../../../../components/window-size-listener';
import SearchPath from '../../../../components/search-path';

import { deleteFilter, updateFilter, addFilter } from '../../FilterActions';
import { getMeta } from '../../FilterReducer';

const FORM_NAME = 'filterButtonForm';


class FilterButton extends Component {
  constructor() {
    super();
    this.state = {
      deleting: false,
      open: false,
      containerWidth: 0,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.switchMapping = this.switchMapping.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    this.updateSearchPath = this.updateSearchPath.bind(this);
    this.renderSearchPathField = this.renderSearchPathField.bind(this);
    this.filterOutcomeNodes = this.filterOutcomeNodes.bind(this);
  }

  componentDidMount() {
    this.props.onClose();
  }

  updateSearchPath(paths) {
    this.props.change('search_paths', paths);
  }

  close() {
    this.props.reset();
    this.setState({ open: false });
    this.props.onClose();
  }


  filterOutcomeNodes(node) {
    const items = node.fields || [];
    // const validTypes = ['picklist', 'boolean'];
    const validTypes = ['picklist'];
    return lodashFilter(items, (item) => {
      return indexOf(validTypes, item.type) >= 0 && item.isLocalOnly !== true;
    });
  }

  isOutcome() {
    return this.props.filter?.tag === 'stage';
  }

  open() {
    const f = { ...this.props.filter };
    this.props.initialize(f);
    this.setState({ open: true });
  }

  handleDelete() {
    const { filter } = this.props;
    const id = filter._id;
    if (id) {
      this.setState({ deleting: true });
      if (this.gridApi) {
        this.gridApi.showLoadingOverlay();
      }
      this.props.dispatch(deleteFilter(id)).then(() => {
        this.props.onDelete();
        this.close();
        this.setState({ deleting: false });
        if (this.gridApi) {
          this.gridApi.hideOverlay();
        }
      });
    }
  }

  switchMapping() {
    const { filter } = this.props;
    const id = filter._id;
    const params = { _id: id, target_field: filter.target_field === 'Id' ? 'UserRoleId' : 'Id' };
    return this.props.dispatch(updateFilter(params))
      .then(
        () => {
          this.props.onSwitch();
          this.close();
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          }
          throw new SubmissionError(e);
        },
      );
  }

  handleSubmit(data) {
    const validFields = ['_id', 'label', 'description'];
    if (!data._id || this.isOutcome()) {
      validFields.push('search_paths');
    }
    const params = pick(data, validFields);
    const action = params._id ? updateFilter : addFilter;
    if (this.gridApi) {
      this.gridApi.showLoadingOverlay();
    }
    return this.props.dispatch(action(params))
      .then(
        ({ filter }) => {
          if (params._id) {
            this.props.onUpdate(filter);
          } else {
            this.props.onCreate(filter);
          }
          if (this.gridApi) {
            this.gridApi.hideOverlay();
          }
          this.close();
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          }
          if (this.gridApi) {
            this.gridApi.hideOverlay();
          }
          throw new SubmissionError(e);
        },
      );
  }


  renderField({
    input, label, type, options, hidden, disabled, componentClass, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label && label !== '' && <ControlLabel>{label}</ControlLabel>}
        {componentClass === 'select' && <FormControl
          {...input}
          componentClass={componentClass}
          type={type}
          disabled={submitting || disabled}
        >
          <option />
          {options.map((o) => {
            const val = o.value || o.name;

            let l = val;
            if (o.label !== undefined) {
              l += ` (${o.label})`;
            }
            return (
              <option key={val} value={val}>
                {l}
              </option>
            );
          })}
        </FormControl>}
        {componentClass !== 'select' && componentClass !== 'textarea' && hidden !== true && <FormControl
          {...input}
          placeholder={label}
          type={type}
          disabled={submitting || disabled}
        />}
        {componentClass === 'textarea' && <FormControl
          {...input}
          placeholder={label}
          type={type}
          componentClass={componentClass}
          rows={3}
          disabled={submitting || disabled}
        />}
        {hidden !== true && <FormControl.Feedback />}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  
  renderSearchPathField({
    label, hidden, disabled, meta: { touched, error },
  }) {
    const { selectedId, submitting, selectedSearchPaths } = this.props;

    const validationState = touched && error ? 'error' : null;

    const isEditing = selectedId !== undefined;
    const isOutcome = this.isOutcome();

    return (
      <FormGroup validationState={validationState}>
        {label && label !== '' && <ControlLabel>{label}</ControlLabel>}
        <SearchPath
          paths={selectedSearchPaths}
          disabled={submitting || disabled}
          readOnly={(isEditing && !isOutcome)}
          onUpdate={this.updateSearchPath}
          selectedSearchPaths={selectedSearchPaths}
          filterNodes={isOutcome ? this.filterOutcomeNodes : null}
          checkFieldType={!isOutcome}
        />
        {hidden !== true && <FormControl.Feedback />}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderModal() {
    const {
      error, handleSubmit, submitting,
      selectedObject, selectedId, selectedField, selectedIsSystemFilter,
      valid,
    } = this.props;
  



    const isEditing = selectedId !== undefined;
    const { deleting } = this.state;
    const targetFieldEditable = isEditing && selectedObject === 'User' && indexOf(['Id', 'UserRoleId'], selectedField) >= 0;

    const isOutcome = this.isOutcome();

    return (
      <Modal show={this.state.open} onHide={this.close} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing && <span>Edit Filter Group</span>}
            {!isEditing && <span>Add Filter Group</span>}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            <div ref={(el) => { this.container = el; }}>
              <WindowResizeListener onResize={this.onWindowResize} />
              {error && <strong className="text-danger">{error}</strong>}
              {selectedIsSystemFilter && <div className="alert alert-warning"><Fa name="exclamation-triangle" /> This is a TruVoice Automation internal filter.</div>}
              <Field
                name="label"
                id="label-field"
                disabled={selectedIsSystemFilter}
                type="text"
                component={this.renderField}
                label="Name"
              />
              <Field name="description" disabled={selectedIsSystemFilter} componentClass="textarea" type="textarea" component={this.renderField} label="Description" />

              <Field
                name="search_paths"
                id="label-field"
                disabled={(selectedIsSystemFilter && !isOutcome)}
                type="text"
                hidden
                component={this.renderSearchPathField}
                label="Target Field"
              />

              {targetFieldEditable &&
                <small>
                  <a href="" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.switchMapping(); }}>
                    {selectedField === 'Id' && <span>Change to SFDC Roles For Mappings</span>}
                    {selectedField === 'UserRoleId' && <span>Change to Sales Rep For Mappings</span>}
                  </a>
                </small>
              }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-sm-6 col-sm-push-6">
                <Button bsStyle="link" disabled={submitting || deleting} onClick={this.close}>
                  {(selectedIsSystemFilter && !isOutcome) && <span>OK</span>}
                  {(!selectedIsSystemFilter || isOutcome) && <span>Cancel</span>}
                </Button>
                {(!selectedIsSystemFilter || isOutcome) &&
                  <Button bsStyle="primary" disabled={submitting || deleting || !valid} type="submit">
                    {isEditing &&
                      <span>
                        {!submitting && <span><Fa name="edit" /> Update</span>}
                        {submitting && <span><Fa name="spinner" spin /> Updating</span>}
                      </span>
                    }
                    {!isEditing &&
                      <span>
                        {!submitting && <span><Fa name="plus" /> Add</span>}
                        {submitting && <span><Fa name="spinner" spin /> Adding</span>}
                      </span>
                    }
                  </Button>
                }
              </div>
              {!selectedIsSystemFilter && isEditing &&
                <div className="col-sm-6 col-sm-pull-6 text-left">
                  {!deleting &&
                    <ConfirmButton onConfirm={this.handleDelete}>
                      <span><Fa name="trash" /> Delete</span>
                    </ConfirmButton>
                  }
                  {deleting &&
                    <Button bsStyle="danger" disabled={submitting || deleting}>
                      <Fa name="spinner" spin /> Deleting
                    </Button>
                  }
                </div>
              }
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  render() {
    const { bsSize, isButton } = this.props;
    return (
      <span>
        {this.renderModal()}
        {isButton &&
          <Button onClick={this.open} bsSize={bsSize} bsStyle="primary">
            {this.props.children}
          </Button>
        }
      </span>
    );
  }
}

const selector = formValueSelector(FORM_NAME);

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    meta: getMeta(state),
    selectedObject: selector(state, 'target_object'),
    selectedField: selector(state, 'target_field'),
    selectedIsSystemFilter: selector(state, 'is_system_filter'),
    selectedId: selector(state, '_id'),
    selectedIsTruSalesFilter: selector(state, '$is_trusales_filter'),
    selectedSearchPaths: selector(state, 'search_paths'),
  };
}

FilterButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filter: PropTypes.shape({
    tag: PropTypes.string,
  }).isRequired,
  valid: PropTypes.bool,
  submitting: PropTypes.bool,
  meta: PropTypes.array.isRequired,
  selectedObject: PropTypes.string,
  selectedField: PropTypes.string,
  selectedId: PropTypes.string,
  selectedIsSystemFilter: PropTypes.bool,
  selectedIsTruSalesFilter: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  children: PropTypes.node,
  bsSize: PropTypes.string,
  onDelete: PropTypes.func,
  submit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func,
  isButton: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  selectedSearchPaths: PropTypes.arrayOf(PropTypes.string),
};
FilterButton.defaultProps = {
  bsSize: null,
  onDelete: () => {},
  onSwitch: () => {},
  onClose: () => {},
  onUpdate: () => {},
  onCreate: () => {},
  isButton: true,
  open: false,
  submitting: false,
  valid: false,
  selectedSearchPaths: [],
};

const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   label: {
  //     length: { maximum: 200 },
  //     presence: { allowEmpty: false },
  //   },
  //   description: {
  //     length: { maximum: 2048 },
  //   },
  //   search_paths: {
  //     presence: { allowEmpty: false },
  //   },
  // };

  const schema = Joi.object({
    label: Joi.string().max(200).required().messages({
      'string.base': 'Label must be a string',
      'string.empty': 'Label is required',
      'any.required': 'Label is required',
      'string.max': 'Label must be at most 200 characters',
    }),
    description: Joi.string().max(2048).allow('', null).messages({
      'string.base': 'Description must be a string',
      'string.max': 'Description must be at most 2048 characters',
    }),
    search_paths: Joi.array().min(1).required().messages({
      'array.base': 'Search paths must be an array',
      'array.min': 'At least one search path is required',
      'any.required': 'Search paths are required',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};


const FilterButtonForm = reduxForm({
  form: FORM_NAME,
  validate,
})(FilterButton);

export default connect(mapStateToProps, { submit })(FilterButtonForm);
